//region block: pre-declaration
//endregion
function setReadTimeout(_this__u8e3s4, readTimeoutMillis) {
  _this__u8e3s4.p5t(readTimeoutMillis);
}
//region block: exports
export {
  setReadTimeout as setReadTimeout12jih49pjfudm,
};
//endregion

//# sourceMappingURL=KtorHttpEngine.js.mjs.map
